import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { TASK_CENTER_CONSTANTS } from '../../constants';

export const headerStyle = css`
  padding: ${theme.spacing(2, 2)};
  gap: ${theme.spacing(1)};
  display: flex;
  align-items: center;
  border-top: 1px solid ${theme.colors.neutral10};
  border-bottom: 1px solid ${theme.colors.neutral10};
`;

export const headerActions = css`
  margin-left: auto;
`;

export const footerStyle = css`
  width: 100%;
  align-items: center;
  display: flex;
  padding: ${theme.spacing(2, 3)};
`;

export const bottomBorder = css`
  border-bottom: 1px solid ${theme.colors.neutral10};
  margin-bottom: ${theme.spacing(2)};
`;

export const fieldContainerStyle = css`
  flex: 1;
  .create-task-title,
  .create-task-description {
    box-shadow: none !important;
    height: fit-content;
  }
`;

export const titleFieldStyle = css`
  border: none;
  padding: 0;
  font-weight: ${theme.font.weight.bold};

  textarea {
    font-size: ${theme.font.size.h2};
    padding: 0;
  }
`;

export const descFieldStyle = css`
  border: none;
  padding: 0;
  margin-top: ${theme.spacing(1.5)};

  textarea {
    padding: 0;
  }
`;

export const formStyle = css`
  padding: ${theme.spacing(2, 3)};
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex: 1;
`;

export const titlePrefixRowStyle = css`
  display: flex;
  align-items: flex-start;
  gap: ${theme.spacing(1)};
`;

export const shakeAnimation = css`
  @keyframes shake {
    0%,
    100% {
      transform: translateX(0);
    }
    20% {
      transform: translateX(-6px);
    }
    40% {
      transform: translateX(6px);
    }
    60% {
      transform: translateX(-4px);
    }
    80% {
      transform: translateX(4px);
    }
  }
  animation: shake 0.4s ease;

  @media (prefers-reduced-motion: no-preference) {
    animation: shake 0.4s ease;
  }
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const getDescFieldHelperTextStyle = (descriptionLength: number) =>
  css`
    visibility: ${descriptionLength < TASK_CENTER_CONSTANTS.DESCRIPTION_WARNING_LIMIT ? 'hidden' : 'visible'};
  `;
